/**
 * featurebase/useFeaturebase.ts
 * Type-safe consumer hook for FeaturebaseContext.
 *
 */

import { useContext } from 'react';
import { FeaturebaseContext, type FeaturebaseContextValue } from './FeaturebaseContext';

/**
 * useFeaturebase — Access Featurebase consent state and SDK readiness.
 *
 * Must be used within FeaturebaseProvider. Throws if used outside the provider.
 *
 * @returns Consent state, readiness state, and consent actions
 * @throws Error if used outside FeaturebaseProvider
 *
 * @example
 * const { consent, readiness, grantConsent } = useFeaturebase();
 */
export function useFeaturebase(): FeaturebaseContextValue {
  const context = useContext(FeaturebaseContext);
  if (!context) {
    throw new Error('useFeaturebase must be used within FeaturebaseProvider');
  }
  return context;
}
